module.exports = __webpack_public_path__ + "static/media/new-background-trees1-1.b5dc09a7.png";